import { useState } from 'react';
import { PARAM_CONFIG, DEPTHS, ParamKey } from '../data/demo';

export type DepthThreshold = { lo: number; hi: number };
export type AllThresholds = Record<ParamKey, DepthThreshold[]>;

const KEY = 'farm_thresholds';

function getDefaults(): AllThresholds {
  const out = {} as AllThresholds;
  for (const p of PARAM_CONFIG) {
    const dt = (p as unknown as { depthThresholds?: DepthThreshold[] }).depthThresholds;
    out[p.key as ParamKey] = dt ? dt.map(t => ({ ...t })) : DEPTHS.map(() => ({ lo: p.lo, hi: p.hi }));
  }
  return out;
}

function load(): AllThresholds {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return getDefaults();
    const parsed = JSON.parse(raw) as AllThresholds;
    // Merge with defaults so new params are always present
    return { ...getDefaults(), ...parsed };
  } catch {
    return getDefaults();
  }
}

export function useThresholds() {
  const [thresholds, setThresholds] = useState<AllThresholds>(load);

  const save = (next: AllThresholds) => {
    localStorage.setItem(KEY, JSON.stringify(next));
    setThresholds(next);
  };

  const reset = () => {
    localStorage.removeItem(KEY);
    setThresholds(getDefaults());
  };

  const getDepthThreshold = (paramKey: ParamKey, depthIndex: number): DepthThreshold => {
    return thresholds[paramKey]?.[depthIndex] ?? { lo: 0, hi: 100 };
  };

  return { thresholds, save, reset, getDepthThreshold };
}
